import React, { Component } from "react";
import arrow from "../../../styles/images/icons/icon_seta.svg";
import axios, { CancelToken } from "axios";
import { connect } from "react-redux";
import { setAlert } from "../../../actions/alertActions";
import "../../../styles/components/ceme/sections/Faq.scss";

class Faq extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      faqs: null,
      faqDeleteAccountOpen: false,
    };
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchFaqs();
  }

  fetchFaqs() {
    axios
      .get("/api/public/questions", {
        params: { type: "005" },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then(({ data }) =>
        this.safeSetState({
          faqs: data.map((faq, idx) => ({
            ...faq,
            open: idx === 0,
          })),
        })
      )
      .catch((err) => {
        console.log("axios", err);
        this.props.setAlert("Ocorreu um erro!", "danger");
      });
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  handleCollapsable(id, open) {
    let newFaqs = this.state.faqs;
    newFaqs[id].open = open;

    this.safeSetState({
      faqs: newFaqs,
    });
  }

  deleteAccountCollapsable() {
    this.safeSetState({ faqDeleteAccountOpen: !this.state.faqDeleteAccountOpen });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="faq">
        <div className="content-section">
          <div className="content">
            <div className="item top">
              <div className="special-title">
                <div className="right">FAQ</div>
              </div>
              <div className="sub-title">Perguntas Frequentes</div>
            </div>

            <div className="item body">
              {this.state.faqs !== null
                ? this.state.faqs.map((faq, idx) => {
                  return (

                    <div className="faq-collapsable" key={idx}>
                      <div
                        className="question"
                        onClick={() => this.handleCollapsable(idx, !faq.open)}
                      >
                        {faq.open ? (
                          <div className="arrow-open">
                            <img src={arrow} alt="arrow" />
                          </div>
                        ) : (
                          <div className="arrow-closed">
                            <img src={arrow} alt="arrow" />
                          </div>
                        )}
                        {faq.questionCode}
                      </div>

                      {faq.open ? (
                        <div className="answer">
                          {faq.answers.map((ans, idx) => {
                            return <span key={idx} dangerouslySetInnerHTML={{ __html: ans.answer }} />;
                          })}
                        </div>
                      ) : null}
                    </div>
                  );
                })
                : null}

              <div className="faq-collapsable" key={123}>
                <div
                  className="question"
                  onClick={() => this.deleteAccountCollapsable()}
                >
                  {this.state.faqDeleteAccountOpen ? (
                    <div className="arrow-open">
                      <img src={arrow} alt="arrow" />
                    </div>
                  ) : (
                    <div className="arrow-closed">
                      <img src={arrow} alt="arrow" />
                    </div>
                  )}
                  Já sou cliente. Como posso pedir a eliminação da minha conta?
                </div>

                {this.state.faqDeleteAccountOpen ? (
                  <div className="answer">
                    <span key={123}>Para pedir a eliminação da sua conta, basta enviar-nos um email com esse pedido, para <a href="mailto: support@go-evio.com?subject=Pedido de eliminação de conta">aqui</a>. No email, pedimos que indique a sua identificação de utilizador (número de telemóvel), assim como a indicação das razões do seu pedido.</span>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  setAlert,
})(Faq);
